import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import {
  ActionIconButton,
  GeneralTableBox,
  HeadTableCell,
  NoDataSkeleton,
  PaginationTable,
  RowTableCell,
  StatusChip,
  TableBodySkeleton,
} from '../../../../common/components';
import { getOptionLabel } from '../../constants/supplierLedgerConstants';
import {
  ADJUSTMENT_STATUS_LABELS,
  ADJUSTMENT_TYPE_OPTIONS,
} from '../../constants/supplierLedgerUiConstants';
import { formatAmount, formatCurrencyAmount } from '../../utils/supplierLedgerFormatters';

const AdjustmentsTable = ({
  adjustments,
  isLoading,
  onCancelAdjustment,
  pagination,
  providerMap,
}) => (
  <>
    <GeneralTableBox>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <HeadTableCell>Fecha</HeadTableCell>
            <HeadTableCell>Proveedor</HeadTableCell>
            <HeadTableCell>Tipo</HeadTableCell>
            <HeadTableCell>Concepto</HeadTableCell>
            <HeadTableCell>Moneda</HeadTableCell>
            <HeadTableCell align="right" sx={{ textAlign: 'right' }}>Importe</HeadTableCell>
            <HeadTableCell align="right" sx={{ textAlign: 'right' }}>Importe ARS</HeadTableCell>
            <HeadTableCell>Estado</HeadTableCell>
            <HeadTableCell>Acciones</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableBodySkeleton />
          ) : adjustments.length ? pagination.paginatedRows.map((adjustment) => (
            <TableRow key={adjustment.uuid} hover>
              <RowTableCell>{adjustment.adjustment_date || '-'}</RowTableCell>
              <RowTableCell>{providerMap[adjustment.uuid_legal_entity] || '-'}</RowTableCell>
              <RowTableCell>{getOptionLabel(ADJUSTMENT_TYPE_OPTIONS, adjustment.adjustment_type)}</RowTableCell>
              <RowTableCell>{adjustment.concept || '-'}</RowTableCell>
              <RowTableCell>{adjustment.currency || 'ARS'}</RowTableCell>
              <RowTableCell align="right" sx={{ textAlign: 'right' }}>{formatCurrencyAmount(adjustment.amount, adjustment.currency)}</RowTableCell>
              <RowTableCell align="right" sx={{ textAlign: 'right' }}>{formatAmount(adjustment.amount_ars)}</RowTableCell>
              <RowTableCell>
                <StatusChip
                  size="small"
                  color={adjustment.status === 'active' ? 'success' : 'error'}
                  label={ADJUSTMENT_STATUS_LABELS[adjustment.status] || adjustment.status}
                />
              </RowTableCell>
              <RowTableCell>
                <Tooltip title={adjustment.status === 'active' ? 'Anular ajuste' : 'El ajuste ya está anulado'}>
                  <span>
                    <ActionIconButton
                      variant="delete"
                      disabled={adjustment.status !== 'active'}
                      onClick={() => onCancelAdjustment(adjustment)}
                    />
                  </span>
                </Tooltip>
              </RowTableCell>
            </TableRow>
          )) : (
            <NoDataSkeleton colSpan={9} message="No hay ajustes de cuenta corriente." />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
    {!!adjustments.length && (
      <PaginationTable
        page={pagination.page}
        totalPages={pagination.totalPages}
        totalCount={pagination.totalCount}
        rowsPerPage={pagination.rowsPerPage}
        onPageChange={pagination.handlePageChange}
        onRowsPerPageChange={pagination.handleRowsPerPageChange}
      />
    )}
  </>
);

export default AdjustmentsTable;
